import { useContext, useState } from "react";
import { ToasterContext } from "../contexts/toaster.context";
import { useApi } from "./api.hook";

export default function useForm<T extends Record<string, any>>(defaultValues: T) {
    const toaster = useContext(ToasterContext);
    const api = useApi();

    const [state, setState] = useState({...defaultValues});

    function set(partialState: Partial<T>) {
        setState(prev => ({...prev, ...partialState}));
    }

    function setFromInput(e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement>) {
        setState(prev => ({...prev, [e.target.name]: e.target.value}));
    }

    const [errors, _setErrors] = useState<Record<string, string>>({});
    function setErrors(errs: Record<string, string>) {
        _setErrors(prev => ({...prev, ...errs}));
    }

    function clearErrors() {
        _setErrors({});
    }

    const [isLoading, setIsLoading] = useState(false);

    function loadText(el: React.ReactNode) {
        return isLoading ? (<div className="loading"></div>) : el;
    }

    async function submit(path: string, options?: {
        onError?: (errs: Record<string, string>) => void;
        onSuccess?: (data: any) => void;
        body?: Record<string, any>;
        method?: "POST"|"PUT"|"PATCH";
    }) {
        setIsLoading(true);

        const res = await api.query(path, {
            method: options?.method || "POST",
            body: options?.body ? options.body : state
        });

        setIsLoading(false);

        if (!res.ok) {
            if (res.data.errors && options?.onError) {
                options.onError(res.data.errors);
            }
        } else {
            if (options?.onSuccess) {
                options.onSuccess(res.data);
            }
        }

        return res;
    }

    return {
        state,
        set,
        errors,
        setErrors,
        clearErrors,
        isLoading,
        setIsLoading,
        submit,
        loadText,
        setFromInput
    };
}